import { render, staticRenderFns } from "./Step2Cpt.vue?vue&type=template&id=54ba3e65&scoped=true&"
import script from "./Step2Cpt.vue?vue&type=script&lang=ts&"
export * from "./Step2Cpt.vue?vue&type=script&lang=ts&"
import style0 from "./Step2Cpt.vue?vue&type=style&index=0&id=54ba3e65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ba3e65",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VTextField})
